module.exports = __webpack_public_path__ + "img/9788954428453.5b9c5b89.jpg";